'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' });

var ChevronRight = function ChevronRight(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ChevronRight = (0, _pure2.default)(ChevronRight);
ChevronRight.muiName = 'SvgIcon';

exports.default = ChevronRight;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ChevronRight.js
// module id = 2248
// module chunks = 0